import { render, staticRenderFns } from "./AskOpinion.vue?vue&type=template&id=2c8ba050&scoped=true&"
import script from "./AskOpinion.vue?vue&type=script&lang=ts&"
export * from "./AskOpinion.vue?vue&type=script&lang=ts&"
import style0 from "./AskOpinion.vue?vue&type=style&index=0&id=2c8ba050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8ba050",
  null
  
)

export default component.exports